import { render, staticRenderFns } from "./gasthreshold.vue?vue&type=template&id=f0dac36c&scoped=true&"
import script from "./gasthreshold.vue?vue&type=script&lang=ts&"
export * from "./gasthreshold.vue?vue&type=script&lang=ts&"
import style0 from "./gasthreshold.vue?vue&type=style&index=0&id=f0dac36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dac36c",
  null
  
)

export default component.exports